import React, { Component } from 'react'
import Collapsible from '../Collapsible'
import CheckBox from '../../components/CheckBox'
import DropdownTreeSelect from "react-dropdown-tree-select"
import isEqual from 'lodash/isEqual'

class FilterGeography extends Component {
  constructor(props){
    super(props)
    this.state = { filterCategories: props.filterCategories, currentNode: 1 }
  }

  componentWillReceiveProps = (nextProps) => {
    if(!isEqual(nextProps.filterCategories, this.state.filterCategories) || nextProps.selectedGeographyIds.length <= 1 || this.state.currentNode == 0) {
      this.setState({ filterCategories: nextProps.filterCategories, currentNode: 1 })
    }
  }

  shouldComponentUpdate = (nextProps) => {
    return !isEqual(nextProps.filterCategories, this.state.filterCategories) || nextProps.selectedGeographyIds.length <= 1 || this.state.currentNode == 0
  }

  geographyChanged = (isChecked, selectedValue) => {
    this.setState({currentNode: selectedValue})
    this.props.onChange({checked: isChecked, value: selectedValue}, [])
  }

  getChildren = (geographies, parentId, gParentId) => {    
    const geo = (geographies
      .filter(x => x.parentId === parentId)
      .map(c => { return { value: c.id, label: c.name, children: this.getChildren(geographies, c.id, parentId), checked: this.shouldBeChecked(geographies, c.id, c.parentId)} })
      .sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)))
    
    return geo
  }

  shouldBeChecked(geographies, currentId, parentId) {
    if(this.props.selectedGeographyIds.includes(currentId)) {
      return true
    } else {
      let parentNode = geographies.filter(x => x.id === parentId)
      if (parentNode.length > 0) {
        this.shouldBeChecked(geographies, parentNode[0].id, parentNode[0].parentId)
      } else {
        return false
      }
    }
  }

  render() {
    // Get distinct all geographies
    const { filterCategories, selectedGeographyIds, ...rest } = this.props

    const geographies = this.state.filterCategories.filter(c => c.type === 5 || c.type === 6 || c.type === 7)

    const distinctGeographies = Array.from(new Set(geographies.map(cat => cat.id)))
      .map(categoryId => {
        return geographies.find(c => c.id === categoryId)
      })

    const parentGeographies = (distinctGeographies
      .filter(x => x.parentId === 0)
      .map(c => { return { value: c.id, label: c.name, children: this.getChildren(distinctGeographies, c.id, 0),checked: this.props.selectedGeographyIds.includes(c.id) } })
      .sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)))

    return (
      (parentGeographies.length > 0) ?
        <Collapsible title='Geography' titleClassName='box-header' id='geo'>
          <div className='box-geographies'>
            <div className='div-separator'>
              <CheckBox
                id='cbGeographyAll'
                Name='cbGeographyAll'
                Checked={this.props.selectedGeographyIds.length === 0}
                onTickChanged={(chk, val) => this.geographyChanged(chk, val)}
                Value='0' text='Show All'
              />
            </div>

            <DropdownTreeSelect id="Geographies" name="geographies" data={parentGeographies} showPartiallySelected={true} 
              showDropdown='always' texts={{ placeholder: 'Search within Geographies' }} {...rest} />
          </div>
        </Collapsible>
        : null
    )
  }
}

export default FilterGeography
